export default "__VITE_ASSET__f227a24f__"